import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { InsightsLensData } from '@upright/ui/common/upright/core/impact-lenses/insights/types';

export function isInsightsImpactBarClickable(data: InsightsLensData, impact: ImpactCategoryId, valence: Valence) {
  const items = data.insights;
  if (!items) {
    return false;
  }
  return !!items.find(d => d.impactCategoryId === impact && d.valence === valence);
}
